import React, { useMemo, useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import DiagnosticStep from '../components/onboarding/DiagnosticStep';
import GradeStep from '../components/onboarding/GradeStep';
import OnboardingShell from '../components/onboarding/OnboardingShell';
import PlacementStep from '../components/onboarding/PlacementStep';
import { diagnosticQuestions } from '../data/onboardingData';

function Onboarding({
  curriculum,
  onComplete,
  onboardingStep,
  onStepChange
}) {
  const [selectedGrade, setSelectedGrade] = useState('7th');
  const [questionIndex, setQuestionIndex] = useState(0);
  const [answers, setAnswers] = useState({});
  const navigate = useNavigate();

  const recommendations = useMemo(() => curriculum.map((group) => ({
    subject: group.subject,
    lesson: group.lessons.find((lesson) => (
      lesson.status === 'available' || lesson.status === 'in-progress'
    ))
  })).filter((item) => item.lesson), [curriculum]);

  const handleAnswer = (questionId, answer) => {
    setAnswers((current) => ({
      ...current,
      [questionId]: answer
    }));
  };

  const handleNextQuestion = () => {
    if (questionIndex < diagnosticQuestions.length - 1) {
      setQuestionIndex((current) => current + 1);
      return;
    }

    onStepChange(3);
  };

  const handleComplete = () => {
    onComplete();
    navigate('/parent');
  };

  const audience = onboardingStep === 2
    ? 'Student check-in'
    : 'Parent setup';

  return (
    <motion.div
      animate={{ opacity: 1, y: 0 }}
      initial={{ opacity: 0, y: 6 }}
    >
      <OnboardingShell audience={audience} step={onboardingStep}>
        {onboardingStep === 1 && (
          <GradeStep
            onContinue={() => onStepChange(2)}
            onSelect={setSelectedGrade}
            selectedGrade={selectedGrade}
          />
        )}

        {onboardingStep === 2 && (
          <DiagnosticStep
            answers={answers}
            onAnswer={handleAnswer}
            onNext={handleNextQuestion}
            questionIndex={questionIndex}
          />
        )}

        {onboardingStep === 3 && (
          <PlacementStep
            onComplete={handleComplete}
            recommendations={recommendations}
          />
        )}
      </OnboardingShell>
    </motion.div>
  );
}

export default Onboarding;